module.exports = __webpack_public_path__ + "media/images/vp/sample.db-9db1de4ec9e2e4deadbcb7fe50133b09.jpg";